import React, { useEffect, useState } from "react";
import {
    Box,
    Center,
    Text,
    Button,
    Link,
    Heading,
    Divider,
    useDisclosure,
    Flex,
    theme,
    Tag,
} from "@chakra-ui/react";
import { GenerateCanva } from "components/generate-canva";
import toast from "react-hot-toast";
import PuffLoader from "react-spinners/PuffLoader";
import Tweets from "components/tweets";
import { useRouter } from "next/dist/client/router";
import { FiChevronLeft } from "react-icons/fi";
import * as analytics from "utils/analytics";
import { ConfirmPopup } from "components/popups/confirmPopup";
import { XYPlot, XAxis, YAxis, HorizontalGridLines, LineSeries, VerticalBarSeries } from 'react-vis';
import { useWindowWidth } from "@react-hook/window-size";

let isLocal = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development');

export const TrendingTopic = ({
    title,
    subtitle,
    desc,
    url,
    image,
    suggestions = [] as any,
    topic,
    topicFull = {} as any,
    tweets,
}) => {

    const [tweetsBest, setTweetsBest] = useState([]);
    const [account, setAccount] = useState<any>({});
    const [isSending, setIsSending] = React.useState(false);
    const [refresh, refresher] = React.useState({});
    const router = useRouter();
    const screenWidth = useWindowWidth();
    const { isOpen: isOpenLimit, onOpen: onOpenLimit, onClose: onCloseLimit } = useDisclosure();


    const onClickSuggestion = async () => {

    }

    let urlPrefix = "/trending";
    // console.log('topicFull:', topicFull);

    return (
        <Box mb={10}>

            <GenerateCanva
                title={title}
                subtitle={subtitle}
                desc={desc}
                url={url}
                image={image}
                suggestions={suggestions}
                nbSuggestions={30}
                placeholder="@patxol"
                onClickSuggestion={onClickSuggestion}
                isLoading={isSending}
                disableSearch={true}
                urlPrefix={urlPrefix}
                utm_source={"trending-topics"}
                headerGradient='linear(to-tr, #F6A050, #E83A5C, #9B4193)'
                headerHeight={{ md: "420px", base: "720px" }}
                childrenMarginTop="60px"
            >
                <Box minH="600px" p={4}>
                    {
                        isSending && (
                            <Center py={10}>
                                <PuffLoader color={"hsl(203, 100%, 36%)"} loading={isSending} css="display: block; margin: 0 auto; border-color: red;" size={50} />
                            </Center>
                        )
                    }
                    {
                        //@ts-ignore
                        !isSending && tweets?.length > 0 && (
                            <Box>
                                <Center w="100%" mt={10}>
                                    <Flex h={{ base: "150px", md: "50px" }} mt={0} w="100%" maxW="1000px" justifyContent="space-between" alignItems="center" flexDir={{ base: "column", lg: "row" }} >

                                        <Flex alignItems="center" >
                                            <Button
                                                variant="secondary"
                                                leftIcon={<FiChevronLeft />}
                                                as="a"
                                                href={"/trending"}
                                            >
                                                {screenWidth < 800 ? "Back" : "X Trends"}
                                            </Button>
                                            <Heading ml={5} textAlign="left" mr={10} fontSize={"2xl"}>Trending tweets about "{topic}"</Heading>
                                        </Flex>
                                        <Box ml="-40px" mt="10px">
                                            <XYPlot height={100} width={350}>
                                                <LineSeries curve={'curveMonotoneX'} data={topicFull?.freqTime?.map((x, index) => {
                                                    return {
                                                        x: index,
                                                        y: x
                                                    }
                                                })} />
                                                <Box position="absolute" top="22px" left="-120px" w="300px" h="1px" p="0" m="0" borderTop={"solid 1px " + theme.colors.gray[100]}></Box>
                                            </XYPlot>
                                        </Box>
                                    </Flex>
                                </Center>
                                <Box mt={5}>
                                    <Tweets
                                        savedTweet={[]}
                                        tweets={tweets}
                                        disableBlur={true}
                                        disableBookmarkButton={true}
                                        refresher={refresher}
                                        refresh={refresh}
                                        disableSaveCsv={true}
                                        disableEmbed={true}
                                        disableEditTweet={true}
                                        disableTryAgain={true}
                                        source="ez4cast"
                                        disableSubMenu={false}
                                        disableName={false}
                                        overrideRootUrl={"/generate-tweets/"}
                                        disableRefreshProfilePic={true}
                                        addSubscribeTile={true}
                                        utmSource="trending-topics"
                                    />
                                </Box>
                            </Box>
                        )
                    }
                    {
                        tweets?.length == 0 && (
                            <Center mb={20}>
                                <Heading fontSize="xl">Sorry, we couldn't find any tweets for this topic</Heading>
                            </Center>
                        )
                    }
                    <Center flexDir={"column"} mb={10}>
                        <Divider maxW="200px" mt={10} />
                        <Heading mt={10} fontSize="2xl">Want to drive more opportunities from X?</Heading>
                        <Text mt={2} fontSize="md">Content Inspiration, AI, scheduling, automation, analytics, CRM.</Text>
                        <Text mt={2} fontSize="md">Get all of that and more in Tweet Hunter.</Text>
                        <Button
                            mt={5}
                            borderRadius={"xl"}
                            bg={"gray.800"}
                            color={"white"}
                            as="a"
                            target="_blank"
                            href="https://tweethunter.io/?utm_source=trending-topics"
                        >
                            <Text mr={3}>Try Tweet Hunter for free</Text>
                        </Button>
                    </Center>
                    {
                        suggestions?.length > 0 && (
                            <Center mt={20} flexDir="column">
                                <Heading fontSize="xl">Check out top tweets from topics:</Heading>
                                <Flex maxW="800px" w="100%" wrap="wrap" mt={5} justifyContent="center">
                                    {
                                        suggestions?.map((suggestion, index) => (
                                            <Link key={index} href={urlPrefix + "/" + suggestion.key}>
                                                <Tag
                                                    key={index}
                                                    m={1}
                                                >
                                                    {suggestion.label}
                                                </Tag>
                                            </Link>
                                        ))
                                    }
                                </Flex>
                                <Link mt={10} href="/trending" textDecoration="underline">
                                    <Text fontSize="lg" fontWeight="600" >Or checkout out all Top Twitter Trends</Text>
                                </Link>
                            </Center>
                        )
                    }
                </Box>
            </GenerateCanva>
        </Box>
    );
};
